module.exports = __webpack_public_path__ + "071935b39ad427386e6eb3cc616e8140.jpg";